import { ActionType, createAction } from "typesafe-actions";
import { Breadcrumb } from "./reducers/breadcrumbs";

export const breadcrumbClickedAction = createAction("breadcrumbClicked")<Breadcrumb>();
export const addBreadcrumbAction = createAction("addBreadcrumb")<Breadcrumb>();
export const setBreadcrumbsAction = createAction("setBreadcrumbs")<Breadcrumb[]>();

export type AppBreadcrumbActions =
  | ActionType<typeof breadcrumbClickedAction>
  | ActionType<typeof addBreadcrumbAction>
  | ActionType<typeof setBreadcrumbsAction>;
